import { useEffect } from "react";
import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { PayslipForm } from "@/components/payroll/PayslipForm";
import { DianReadinessBanner } from "@/components/companies/DianReadinessBanner";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute("/companies/$companyId/nomina/payslips/new")({
  component: NewPayslipPage,
});

function NewPayslipPage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewPayslipContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewPayslipContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const navigate = useNavigate();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4">
      <DianReadinessBanner companyId={companyId} documentKind="nomina" />
      <Link
        to="/companies/$companyId/nomina/payslips"
        params={{ companyId }}
        className="inline-flex w-fit items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        {t("payroll.payslip.new.back")}
      </Link>
      <h1 className="text-2xl font-semibold tracking-tight">
        {t("payroll.payslip.new.title")}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t("payroll.payslip.new.subtitle")}
      </p>

      <PayslipForm
        companyId={companyId}
        onCreated={(result) => {
          void navigate({
            to: "/companies/$companyId/nomina/payslips/$payslipId",
            params: { companyId, payslipId: result.id },
          });
        }}
      />
    </div>
  );
}
